import React from 'react'
import { Outlet } from 'react-router'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'

import BillBrandLogo from '@sputnik/components/BillBrandLogo'
import BillDescription from '@sputnik/components/BillDescription'
import RecaptchaDisclaimer from '@sputnik/components/RecaptchaDisclaimer'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

import SignInMarketingContent from './SignInMarketingContent'
import styles from './styles.module.scss'

export const SignInPage = () => {
  const [getClassName] = useNameFormatter('SignInPage')
  const { track } = useWebTracking()

  return (
    <div className={styles[getClassName('')]}>
      <div className={`${styles[getClassName('container')]} dd-privacy-allow`}>
        <BillBrandLogo />
        <div className={styles[getClassName('grid')]}>
          <SignInMarketingContent />
          <div className={styles[getClassName('content')]}>
            <Outlet />
            <div className={styles[getClassName('disclosures')]}>
              <RecaptchaDisclaimer onClick={() => track('se_signup__terms_and_services__fired')} />
              <BillDescription />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SignInPage
